import { Notify } from 'quasar';
import {
  EnqueteModel,
  EnqueteGetAttributes,
  EnqueteSendAttributes,
  EnqueteCollection,
} from 'src/models/EnqueteModel';
import {
  EnqueteAdapterInteface,
  ListEnquetesInput as BaseListEnquetesInput,
} from 'src/adapter/EnqueteAdapterInterface';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';
export type ListEnquetesInput = BaseListEnquetesInput;
export class EnqueteApiClass {
  adapter: EnqueteAdapterInteface;
  constructor(adapter: EnqueteAdapterInteface) {
    this.adapter = adapter;
  }
  async listEnquetes(
    conditions: ListEnquetesInput
  ): Promise<{ total: number; data: EnqueteCollection }> {
    try {
      conditions?.page;
      const res = await this.adapter.listEnquetes(conditions);
      return {
        total: res.total,
        data: res.data.map(
          (enquete: EnqueteGetAttributes) => new EnqueteModel(enquete)
        ),
      };
    } catch (e: any) {
      throw apiErrorHandler(e);
    }
  }
  async getEnquete(id: string): Promise<EnqueteModel> {
    try {
      const enquete = await this.adapter.getEnquete(id);
      return new EnqueteModel(enquete);
    } catch (e: any) {
      throw apiErrorHandler(e);
    }
  }
  async createEnquete(
    attributes: EnqueteSendAttributes
  ): Promise<EnqueteModel> {
    try {
      const account = await this.adapter.createEnquete(attributes);
      return new EnqueteModel(account);
    } catch (e: any) {
      throw apiErrorHandler(e);
    }
  }
  async updateEnquete(
    id: string,
    attributes: EnqueteSendAttributes
  ): Promise<EnqueteModel> {
    try {
      const account = await this.adapter.updateEnquete(id, attributes);
      return new EnqueteModel(account);
    } catch (e: any) {
      throw apiErrorHandler(e);
    }
  }
  async deleteEnquete(id: string): Promise<boolean> {
    try {
      const res = await this.adapter.deleteEnquete(id);
      Notify.create({
        type: 'positive',
        message: '削除しました',
      });
      return res;
    } catch (e: any) {
      throw apiErrorHandler(e);
    }
  }
  async start(id: string): Promise<boolean> {
    try {
      const res = await this.adapter.start(id);
      Notify.create({
        type: 'positive',
        message: '開始しました',
      });
      return res;
    } catch (e: any) {
      throw apiErrorHandler(e);
    }
  }
  async finish(id: string): Promise<boolean> {
    try {
      const res = await this.adapter.finish(id);
      Notify.create({
        type: 'positive',
        message: '終了しました',
      });
      return res;
    } catch (e: any) {
      throw apiErrorHandler(e);
    }
  }
}
